import React, { useState, useEffect, useRef } from "react";
import {
    areaListAPI,
    getAreaDetails,
    listPlantsApi,
    getPlantDetails,
    zoneCreate,
    zoneListing,
    zoneUpdate,
    getzoneDetails,
} from "../utils/apiServices";
import Breadcrumb from "./Breadcrumb";
import FooterButton from "./FooterButton";
import Header from "./Header";
import DataNotFound from "./DataNotFound";
import { useLocation, useNavigate } from "react-router-dom";
import { apiCollection } from "../utils/apiCollection";
import { ConfirmModal } from "./ConfirmModal";
import { ErrormModal } from "./ErrorModal";
import { SuccessModal, ErrorModal } from "./FormComponents";
import { createCoords } from "../constants/MapContainer";
import { zoneDetailsMap } from "../constants/MapContainer";
import axios from "axios";
import { AUTH_CODE, path_Operation } from "../constants/constVariables";
import BackButton from "../clientComponents/BackButton/BackButton";
import { CustomTab } from "../atomicComponents";
import { useAuthorizationContext } from "../providers/AuthorizationHandler/AuthorizationHandler";
import { postUsageAnalyticsCall } from "../constants/Utils";
import { APILimit } from "../constants/constVariables";
import { Regex } from "../constants/contants"
export default function AddNewZone() {
    const { user, logoutUser } = useAuthorizationContext();
    const location = useLocation();
    const navigate = useNavigate();

    const descriptionRef = useRef("");
    const parkingCapacityRef = useRef("");
    const zoneNameRef = useRef("");
    const plantRef = useRef("");
    const zoneRef = useRef("");
    const areaRef = useRef("");
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
    const [selectedZone, setSelectedZone] = useState([]);
    const [title, setTitle] = useState("");
    const [data, setData] = useState({});
    const [currentData, setCurrentData] = useState({});
    const [pageLeaveTime, setPageLeaveTime] = useState();

    const check = async () => {
        if (location?.state?.edit) {
            // console.log("PLANT DATAAAA:", location.state.data);
            plantRef.current.value = location.state.data.plant_data.name;
            areaRef.current.value = location.state.data.area_data.name;
            if (
                location?.state?.data?.parent_zone_data[
                    location.state.data.parent_zone_data.length - 1
                ]?.name
            ) {
                zoneRef.current.value =
                    location.state.data.parent_zone_data[
                        location.state.data.parent_zone_data.length - 1
                    ].name;
            }
            // console.log("location = ",location.state.data.area_data.id)
            zoneNameRef.current.value = location.state.data.name;
            descriptionRef.current.value = location.state.data.description;
            parkingCapacityRef.current.value = location.state.data.parking_capacity;
            const responseAreaVINs = await getAreaDetails(location?.state?.data?.area_data?.id);
            zoneDetailsMap(
                location.state.data.plant_data?.coordinates[0],
                location.state.data.area_data?.zoom,
                location.state.data.area_data?.coordinates,
                location.state.data,
                location.state.data?.parent_zone_data,
                [],
                responseAreaVINs?.data?.data?.vin_data
            );
        } else {
            fetchPlant();
        }
    };
    const fetchPlant = async () => {
        const response = await listPlantsApi(user.plants[0]);
        // console.log("Plant Listr", response);
        if (response?.data?.data) {
            const a = response?.data?.data?.plant_data?.filter(d => user?.plants?.includes(d?.plant_ids));
            // console.log("outside", a, response.data.data['plant_data'])
            if (response?.data?.length !== 0) {
                setCurrentData({
                    ...currentData,
                    currentPlant: a,
                });
            } else {
                setCurrentData({ ...currentData, currentPlant: [] });
            }
            setData({ ...data, plantId: a[0]?.plant_id });
        }
    };
    const fetchArea = async (plantId) => {
        if (plantId != null || plantId != undefined) {
            const response = await areaListAPI(APILimit, 0, plantId, "all");
            // console.log("Area response = ",plantId,response,response.data.data[0]?.area_id)
            if (response?.data?.data[0]?.area_id) {
                setData({ ...data, areaId: response.data.data[0].area_id });
            }
            if (response?.data?.count != 0) {
                setCurrentData({ ...currentData, currentArea: response.data.data });
            } else {
                setCurrentData({ ...currentData, currentArea: [] });
                setData({ ...data, areaId: null });
            }
        }
    };
    const fetchZone = async (areaId, plantId) => {
        // console.log("aadf = ", areaId)
        if (areaId) {
            const response = await zoneListing(APILimit, 0, areaId, "all", plantId);
            // console.log("object = ", response,response.data.data)
            setData({ ...data, zoneId: response?.data?.data });
            setCurrentData({ ...currentData, currentZone: response.data.data });
        } else {
            setCurrentData({ ...currentData, currentZone: [] });
        }
    };
    const apiCallDrop = async () => {
        // console.log("parentZoneData:",zoneRef.current.value=="");
        if (data.areaId != null && data.plantId != null && data.zoneId === null) {
            // console.log("insideee if");
            const responseArea = await getAreaDetails(data.areaId);
            const responsePlant = await getPlantDetails(data.plantId);
            // console.log("areaaaaaaaaaaaaaaa = ", responseArea)
            createCoords(responsePlant.data.data.plant_data.coordinates[0], 22, responseArea.data.data.area_data, null, setSelectedZone, true, true, "Zone", false, responseArea.data.data.vin_data);
        } else if (data.areaId != null && data.plantId != null && (data.zoneId !== null || data.zoneId in window)) {
            // console.log("insideee else", data.zoneId, zoneRef.current.value);
            const responseArea = await getAreaDetails(data.areaId);
            const responsePlant = await getPlantDetails(data.plantId);
            // console.log("areaaaaaaaaaaaaaaa = ", responseArea)
            // const responseZone = await getzoneDetails(data.zoneId);
            // console.log("insideee === ",data.zoneId)
            createCoords(responsePlant.data.data.plant_data.coordinates[0], 22, responseArea.data.data.area_data, data.zoneId, setSelectedZone, true, true, "Zone", zoneRef.current.value ? true : false, responseArea.data.data.vin_data);
        }
    };
    useEffect(() => {
        apiCallDrop();
    }, [data]);
    useEffect(() => {
        check();
        setPageLeaveTime(new Date())
    }, [""]);
    useEffect(() => {
        fetchArea(data.plantId);
    }, [data.plantId]);
    useEffect(() => {
        fetchZone(data.areaId, data.plantId);
    }, [data.areaId]);
    useEffect(() => { }, [currentData.currentPlant]);
    useEffect(() => { }, [currentData.currentArea]);
    useEffect(() => { }, [currentData.currentZone]);
    useEffect(() => {
        validation();
    }, [selectedZone]);
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    const validation = () => {
        if (zoneNameRef.current.value !== "") {
            zoneNameRef.current.value = zoneNameRef.current.value.replace(Regex.specialCharacter, '');
        }
        if (descriptionRef.current.value !== "") {
            descriptionRef.current.value = descriptionRef.current.value.replace(Regex.description, '');
        }
        var nameError = document.getElementById("nameError");
        var capacityError = document.getElementById("capacityError");
        // console.log("outside = ", zoneNameRef.current.value)
        if (location?.state?.edit) {
            // console.log("zoneNameRef = ", zoneNameRef.current.value)
            if (zoneNameRef.current.value !== location.state.data.name || descriptionRef.current.value !== location.state.data.description || parkingCapacityRef.current.value !== location.state.data.parking_capacity) {
                // console.log("zoneNameRef 2 = ", zoneNameRef.current.value)
                if (!(zoneNameRef.current.value.length >= 2 && zoneNameRef.current.value.length < 30)) {
                    // console.log("inside iffff", nameError);
                    nameError.innerHTML =
                        "*Zone name should be atleast 2 character and atmost 50 character";
                    buttonToggle("disabled");
                } else {
                    nameError.innerHTML = "";
                    if (Number(parkingCapacityRef.current.value) === 0) {
                        capacityError.innerHTML =
                            "*Parking Capacity should be greater than 0";
                        buttonToggle("disabled");
                    }
                    //  else if (Number(parkingCapacityRef.current.value) > 20) {
                    //   capacityError.innerHTML =
                    //     "*Parking Capacity should not be greater than 20";
                    //   buttonToggle("disabled");
                    // } 
                    else {
                        capacityError.innerHTML = "";
                        buttonToggle("enabled");
                    }
                }
            } else {
                buttonToggle("disabled");
            }
        } else {
            if (zoneNameRef.current.value !== "" && selectedZone.length > 2) {
                if (
                    !(
                        zoneNameRef.current.value.length >= 2 &&
                        zoneNameRef.current.value.length < 30
                    )
                ) {
                    //console.log("inside iffff", nameError);
                    nameError.innerHTML =
                        "*Zone name should be atleast 2 character and atmost 50 character";
                    buttonToggle("disabled");
                } else {
                    nameError.innerHTML = "";
                    if (Number(parkingCapacityRef.current.value) === 0) {
                        //console.log("inside iffff", capacityError);
                        capacityError.innerHTML =
                            "*Parking Capacity should be greater than 0";
                        buttonToggle("disabled");
                    }

                    // else if (zoneRef.current.value && Number(parkingCapacityRef.current.value) > 20) {
                    //     capacityError.innerHTML = "*Parking Capacity should not be greater than 20"
                    //     buttonToggle("disabled")
                    // }
                    else {
                        capacityError.innerHTML = "";
                        buttonToggle("enabled");
                    }
                }
            } else {
                buttonToggle("disabled");
            }
        }
    };
    const toggleModal = () => {
        navigate("/zone-master");
    };
    const plantChange = (value) => {
        setData({ ...data, plantId: value });
    };
    const areaChange = (value) => {
        setData({ ...data, areaId: value });
        fetchZone();
    };
    const zoneChange = async (value) => {
        if (value === "") {
            fetchZone(data.areaId, data.plantId);
        } else {
            const responseZone = await getzoneDetails(value);
            setData({ ...data, zoneId: responseZone?.data?.data });
        }
    };
    const buttonToggle = (value) => {
        if (value === "enabled") {
            const button = document.getElementById("SUBMIT");
            button.disabled = false;
            button.classList.remove("button-disabled");
            button.classList.add("button-enabled");
            button.style.cursor = "pointer";
        } else {
            const button = document.getElementById("SUBMIT");
            button.classList.remove("button-enabled");
            button.classList.add("button-disabled");
            button.style.cursor = "unset";
            button.disabled = true;
        }
    };
    const handleButton = () => {
        if (location?.state?.edit) {
            buttonToggle("disabled");
            editZone();
        } else {
            buttonToggle("disabled");
            createZone();
        }
    };
    const editZone = async () => {
        const payload = {
            plant_id: location.state.data.plant_data.id,
            area_id: location.state.data.area_data.id,
            zone_id: location.state.data.id,
            parent_zone_id: "",
            zone_name: zoneNameRef.current.value,
            zone_description: descriptionRef.current.value,
            parking_capacity: parkingCapacityRef.current.value,
            zone_coordinates: location.state.data.coordinates,
            zoom: 17,
            updated_by: user.name,
            updated_by_id: user.userID
        };
        //console.log("payload", payload)
        if (zoneNameRef.current.value !== "") {
            //console.log("Create Zone Payload = ", payload)
            const response = await zoneUpdate(payload).then((res) => {
                //console.log(res.data);
                if (res.status == 200) {
                    setTitle("Zone Updated Successfully");
                    setModalIsOpen(true);
                    // console.log("fdffdfd = ", location?.pathname)
                    const a = path_Operation?.filter((d, i) => {
                        return d?.name == "edit-zone"
                    })
                    // console.log("A = ", a[0]?.operation)
                    postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "edit-zone", new Date, a[0]?.operation ? a[0]?.operation : 'view', 0)
                } else {
                    setTitle(res.response.data.message);
                    setErrorModalIsOpen(true);
                }
            }).catch((error) => {
                setTitle(error.response.data.message);
                setErrorModalIsOpen(true);
            });
        } else {
            setErrorModalIsOpen(true);
        }
    };
    const createZone = async () => {
        const payload = {
            plant_id: plantRef.current.value,
            area_id: areaRef.current.value,
            parent_zone_id: zoneRef.current.value,
            zone_name: zoneNameRef.current.value,
            zone_description: descriptionRef.current.value,
            parking_capacity: parkingCapacityRef.current.value,
            zone_coordinates: selectedZone,
            zoom: 17,
            created_by: user.name,
            created_by_id: user.userID
        };
        if (zoneNameRef.current.value !== "" && areaRef.current.value !== "") {
            //console.log("Create Area Payload = ", payload)
            const response = await zoneCreate(payload)
                .then((res) => {
                    //console.log(res.data);
                    if (res.status == 201) {
                        setTitle("New Zone created successfully");
                        setModalIsOpen(true);
                        // console.log("fdffdfd = ", location?.pathname)
                        const a = path_Operation?.filter((d, i) => {
                            return d?.name == "create-zone"
                        })
                        // console.log("A = ", a[0]?.operation)
                        postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "create-zone", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    setTitle(error.response.data.message);
                    setErrorModalIsOpen(true);
                });
        } else {
            setErrorModalIsOpen(true);
        }
    };

    // const browserBack = () => {
    //     navigate(-1);
    // };
    return (
        <>
            {
                <>
                    {/* <Breadcrumb /> */}
                    <div className="breadcrumb">
                        <BackButton
                            basePath={"zone master"}
                            action={location?.state?.edit ? "edit zone" : "add new zone"}
                            handleClick={() => { navigate(-1) }}
                        />
                    </div>
                    <div className="headerwithcount">
                        <div className="countdiv">
                            <CustomTab
                                isSelected={false}
                                withOutCount
                                title={location?.state?.edit ? "Edit Zone" : "Add New Zone"}
                            />
                        </div>
                        <div className="blankdiv">
                            <span className="vin-search-head-container">
                                {location?.state?.edit
                                    ? null
                                    : "Note: Make sure all mandatory fields are filled and the zone is plotted."}
                            </span>
                        </div>
                    </div>
                    {/* <Header name={location?.state?.edit ? "Edit Zone" : "Add New Zone"} search={false} filter={false} inputPlaceholder={location?.state?.edit ? null : "Note: Make sure all mandatory fields are filled and the zone is plotted."} /> */}
                    <div className="vin-details-container">
                        <div className="zone-details-main-container">
                            <div className="vin-details-header mediumFont">
                                {location?.state?.edit ? "Edit Zone" : "Create Zone"}
                            </div>
                            <div className="zone-detail-container">
                                <div className="zone-detail-inner-container">
                                    <div className="zone-header-data-container">
                                        <span className="zone-header">Select plant*</span>
                                        <select
                                            className="zone-input-fild zone-dropdown-main regularFont"
                                            ref={plantRef}
                                            defaultValue={"1"}
                                            disabled={location?.state?.edit}
                                            onChange={(e) => plantChange(e.target.value)}
                                        >
                                            {location?.state?.edit ? (
                                                <option
                                                    value={location.state.data.plant_data.name}
                                                    selected
                                                >
                                                    {location.state.data.plant_data.name}
                                                </option>
                                            ) : (
                                                currentData.currentPlant?.map((plant, index) => {
                                                    return (
                                                        <>
                                                            <option key={index} value={plant["plant_id"]}>
                                                                {plant["plant_name"]}
                                                            </option>
                                                        </>
                                                    );
                                                })
                                            )}
                                        </select>
                                    </div>
                                    <div className="zone-header-data-container">
                                        <span className="zone-header">Select Area*</span>
                                        <select
                                            className="zone-input-fild zone-dropdown-main regularFont"
                                            ref={areaRef}
                                            defaultValue={"1"}
                                            disabled={location?.state?.edit}
                                            onChange={(e) => areaChange(e.target.value)}
                                        >
                                            {location?.state?.edit ? (
                                                <option
                                                    value={location.state.data.area_data.name}
                                                    selected
                                                >
                                                    {location.state.data.area_data.name}
                                                </option>
                                            ) : (
                                                currentData.currentArea?.map((area, index) => {
                                                    return (
                                                        <>
                                                            <option key={index} value={area["area_id"]}>
                                                                {area["area_name"]}
                                                            </option>
                                                        </>
                                                    );
                                                })
                                            )}
                                        </select>
                                    </div>
                                    <div className="zone-header-data-container">
                                        <span className="zone-header">Select Parent Zone</span>
                                        <select
                                            className="zone-input-fild zone-dropdown-main regularFont"
                                            ref={zoneRef}
                                            disabled={location?.state?.edit}
                                            onChange={(e) => zoneChange(e.target.value)}
                                        >
                                            <option value="">No Parent Zone</option>
                                            {location?.state?.edit ? (
                                                location?.state?.data?.parent_zone_data[0]?.name ? (
                                                    <option
                                                        value={
                                                            location.state.data.parent_zone_data[
                                                                location.state.data.parent_zone_data.length - 1
                                                            ].name
                                                        }
                                                        selected
                                                    >
                                                        {
                                                            location.state.data.parent_zone_data[
                                                                location.state.data.parent_zone_data.length - 1
                                                            ].name
                                                        }
                                                    </option>
                                                ) : (
                                                    <option value="">No Parent Zone</option>
                                                )
                                            ) : (
                                                currentData.currentZone?.map((zone, index) => {
                                                    return (
                                                        <>
                                                            <option key={index} value={zone["zone_id"]}>
                                                                {zone["zone_name"]}
                                                            </option>
                                                        </>
                                                    );
                                                })
                                            )}
                                        </select>
                                    </div>
                                    <div className="zone-header-data-container">
                                        <span className="zone-header">Zone Name*</span>
                                        <div className="errorMessage_container">
                                            <input
                                                className="zone-input-fild"
                                                type="text"
                                                min="0"
                                                max="250"
                                                onChange={() => validation()}
                                                ref={zoneNameRef}
                                                pattern="/^[a-zA-Z0-9_]+$/"
                                                required="required"
                                            />
                                            <span id="nameError" className="title"></span>
                                        </div>
                                    </div>
                                    <div className="zone-header-data-container">
                                        <span className="zone-header">Parking Capacity*</span>
                                        <div className="errorMessage_container">
                                            <input
                                                className="zone-input-fild"
                                                type="number"
                                                min="0"
                                                max="20"
                                                pattern="^(?:0*(?:[0-9]|[1-9][0-9][0-9]?|[1-4][0-9][0-9][0-9])(?:[.][0-9])?|20(?:[.]0)?)$"
                                                onInput={(e) => {
                                                    parkingCapacityRef.current.value = Math.abs(
                                                        parkingCapacityRef.current.value
                                                    );
                                                }}
                                                onChange={() => validation()}
                                                ref={parkingCapacityRef}
                                                required="required"
                                            />
                                            <span id="capacityError" className="title"></span>
                                        </div>
                                    </div>
                                    <div className="zone-header-data-container">
                                        <span className="zone-header">Description</span>
                                        <textarea
                                            className="zone-input-fild"
                                            placeholder="200 words only"
                                            onChange={() => validation()}
                                            rows="4"
                                            cols="50"
                                            maxLength={200}
                                            ref={descriptionRef}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="zone-map-container">
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "12px",
                                    boxShadow: "0 3px 6px rgb(0 0 39 / 15%)",
                                }}
                                id="map_container"
                            ></div>
                            <div id="floating-panel">Delete Polygon</div>
                        </div>
                    </div>
                    <div className="horizontal-line" style={{ marginTop: "1rem" }}></div>
                    <div
                        className="vin-details-footer"
                        style={{ flexDirection: "row-reverse" }}
                    >
                        <FooterButton
                            shouldEnable={false}
                            value="SUBMIT"
                            backgroundColor="#82C1A7"
                            secondaryColor="#488f71"
                            handle={handleButton}
                            authOperation={AUTH_CODE.CREATE}
                        />
                    </div>
                    {
                        <SuccessModal
                            open={isModalOpen}
                            handleClose={() => toggleModal()}
                            title={title}
                        />
                    }
                    {
                        <ErrorModal
                            open={isErrorModalOpen}
                            handleClose={() => setErrorModalIsOpen(false)}
                            title={title}
                        />
                    }
                </>
                // :
                // <DataNotFound />
            }
            <style jsx>
                {`
                .footer-button {
                    align-items: center;
                    border: none;
                    border-radius: 4px;
                    box-shadow: 0 3px 3px rgb(0 0 67 / 13%);
                    color: #fff;
                    cursor: pointer;
                    display: flex;
                    font-weight: 700;
                    line-height: 19px;
                    padding: 0.5rem 2rem;
                    text-align: center;
                    text-transform: uppercase;
                    white-space: nowrap;
                }
                .vin-search-head-container {
                    text-transform: unset;
                    color: #F17C7C;
                    font-size: var(--smallFontSize);
                    font-weight: 400;
                    padding-left: 10px;
                  }
                  #floating-panel {
                    position: absolute;
                    top: 10px;
                    left: 100px;
                    display: none;
                    background: rgb(241, 124, 124);
                    padding-box rgb(255, 255, 255);
                    border: 0;
                    cursor: pointer;
                    margin: 0;
                    display: none;
                    outline: 0;
                    align-items: center;
                    user-select: none;
                    border-radius: 0;
                    vertical-align: middle;
                    -moz-appearance: none;
                    justify-content: center;
                    text-decoration: none;
                    -webkit-appearance: none;
                    -webkit-tap-highlight-color: rgb(241, 124, 124);;
                    color: #fff;
                    padding: 11px 23px;
                    font-size: 0.875rem;
                    min-width: 64px;
                    box-sizing: border-box;
                    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                    font-weight: 600;
                    line-height: 1.75;
                    border-radius: 4px;
                    letter-spacing: 0.02857em;
                    text-transform: uppercase;
                    font-size: var(--smallFontSize);
                }
                #floating-panel:hover {
                    background: #ea3a3a;
                    color: #fff;
                }
                .gmnoprint[role=menubar]{
                    display: flex;
                    right: 55px !important;
                    top: 10px !important;
                    border-radius: 6px;
                    display: flex;
                    margin: 0 !important;
                }
                .gmnoprint[role=menubar] > div > button {
                    background: #FFFFFF !important;
                    box-shadow: 0px 3px 6px rgba(0, 0, 41, 0.1) !important;
                    border-radius: 6px !important;
                    margin: 0 5px !important;
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;                    
                }

                    `}
            </style>
        </>
    );
}
